module.exports = __webpack_public_path__ + "static/media/Mount Sinai Health Systems.0c2e0859.png";